import React from 'react';

import { MCButton, TextField } from 'src/components/basic';
import { BASE_ICONS } from 'src/components/svg';
import BaseComponent from 'src/components/BaseComponent';

import { lang, remCss, withRouter } from 'src/helpers';

import model from './model';
import LANG_CONST from 'src/helpers/lang/const';

class Question extends BaseComponent {
  state = {
    apiName: 'addQuestions',
    adding: false
  };
  blurTimeOutId = null;
  componentDidMount() {
    model.subscribe(this.subscription);
    this.setState({ key: 0 });
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }
  saveQuestions = (e) => {
    e?.preventDefault();
    if (this.blurTimeOutId) clearTimeout(this.blurTimeOutId);
    this.setState({ api: 'addQuestions' });
    model.saveQuestions(false, () => {
      this.setState({ key: this.state.key + 1 });
      setTimeout(() => {
        if (this.formRef) {
          const { scrollHeight, clientHeight } = this.formRef;
          this.formRef.scrollTo({
            top: scrollHeight - clientHeight,
            behavior: 'smooth'
          });
        }
      }, 500);
    });
  };
  cancelQuestions = (e) => {
    e.preventDefault();
    if (this.blurTimeOutId) clearTimeout(this.blurTimeOutId);
    console.log('cancelQuestions');
    model.resetQuestions();
    this.setState({ adding: false });
  };

  delQuestion = (delIds) => {
    this.setState({ api: 'delQuestions' });
    const { handleChange } = model;
    const list = model.input('questions');
    handleChange('questions', [...list.filter((item, i) => delIds.indexOf(i) === -1)]);
    model.saveQuestions(true);
  };
  renderQuestions = () => {
    const { handleChange } = model;
    const { invalid, loading } = model.getApiState(this.state.api);

    return (
      <form className={'mc-setting-question'} onSubmit={this.saveQuestions}>
        <div className={'mc-header'}>
          <div className={'mc-title'}>{lang.t(LANG_CONST.titles.appointment_questions)}</div>
        </div>
        <div className={'mc-form'} ref={(ref) => (this.formRef = ref)}>
          {model.input('questions').map((ques, i) => (
            <div className={'mc-form-group'} key={'question' + i}>
              <div className={'mc-question'}>{ques}</div>
              <MCButton
                primary
                light
                radius
                iconname={BASE_ICONS.CLOSE}
                width={50}
                padding={8}
                type={'button'}
                onClick={() => this.delQuestion([i])}
              />
            </div>
          ))}
        </div>
        {this.state.adding ? (
          <>
            <TextField
              style={{ marginLeft: remCss(30), marginRight: remCss(30) }}
              template={6}
              name={'newQuestion'}
              value={model.input('newQuestion')}
              onChange={(n, v) => handleChange('newQuestion', v)}
              onBlur={(n, v) => {
                this.blurTimeOutId = setTimeout(() => {
                  if (v) this.saveQuestions();
                }, 200);
              }}
              key={this.state.key || 0}
              autoFocus={true}
              invalid={invalid}
              autoComplete={false}
              requiredErrorMessage={lang.t(LANG_CONST.validation.need_input_ques)}
              disabled={loading}
              inputProps={{ maxLength: 1000 }}
            />
            <div className={'mc-flex-20 mc-p30'}>
              <div className={'mc-grow'}></div>
              {!loading && (
                <MCButton
                  light
                  primary
                  medium
                  radius
                  disabled={loading}
                  type={'button'}
                  onClick={this.cancelQuestions}
                >
                  {lang.t(LANG_CONST.buttons.cancel)}
                </MCButton>
              )}

              <MCButton
                dark
                primary
                medium
                radius
                type={'submit'}
                disabled={loading}
                loading={loading}
                label={LANG_CONST.buttons.save}
              />
            </div>
          </>
        ) : (
          <div className={'mc-flex-20 mc-plr30 mc-pb20'}>
            <div className={'mc-grow'}></div>
            <MCButton
              medium
              tertiary
              iconname={BASE_ICONS.PLUS}
              label={LANG_CONST.buttons.add_question}
              onClick={() => this.setState({ adding: true })}
            />
          </div>
        )}
      </form>
    );
  };

  render() {
    return <div className={'mc-main-content'}>{this.renderQuestions()}</div>;
  }
}

export default withRouter(Question);
